// import LS from "../../helpers/localStorage";

export default {
  info: null, // LS.getItem("turnInfo")
  timer: null,
  epoch: null,
  infoErrorCount: 0
};
